import { render, staticRenderFns } from "./NextEvent.vue?vue&type=template&id=56698e23&lang=pug&"
import script from "./NextEvent.vue?vue&type=script&lang=js&"
export * from "./NextEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports